// extracted by mini-css-extract-plugin
module.exports = {"scale":"styles_scale__OvNu2","scale__wrapper":"styles_scale__wrapper__FAb3J","scale__inner":"styles_scale__inner__2JiNc","scale__value":"styles_scale__value__3J-aX"};